import React from "react";

const Context = React.createContext();

function MainProviderSearch({children}) {

    const [state, setState] = React.useState("")

    return <Context.Provider value={{state, setState}}>{children}</Context.Provider>
}

export {Context, MainProviderSearch}
